'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = JobNextSteps;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function JobNextSteps(_ref) {
  var title = _ref.title,
      text = _ref.text,
      linkText = _ref.linkText,
      href = _ref.href,
      loading = _ref.loading;

  if (loading) {
    return _react2.default.createElement(
      'div',
      { className: 'job-step' },
      _react2.default.createElement(
        'h3',
        null,
        title
      ),
      _react2.default.createElement(
        'p',
        null,
        'Loading'
      )
    );
  }

  return _react2.default.createElement(
    'div',
    { className: 'job-step' },
    _react2.default.createElement(
      'h3',
      null,
      title
    ),
    _react2.default.createElement(
      'p',
      null,
      text
    ),
    _react2.default.createElement(
      _reactRouter.Link,
      { to: href },
      linkText
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/JobNextSteps/Step.jsx
// module id = 1208
// module chunks = 0